module.exports = __webpack_public_path__ + "static/media/landing_circle.f205c458.png";